import React, { useEffect, useState } from 'react';
import genStyles from '../generale.module.css';
import CollectionService from '../../service/CollectionService';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { apiCollectionState, collectionsState, loadingState, toastState, userDataState } from '../../atoms/CollectionState';


export default function AddCollectionForm({ onClose, objetCur }) {
    const [collectionName, setCollectionName] = useState('');
    const [titlePop, setTitlePop] = useState('');
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);     
    const setCollections = useSetRecoilState(collectionsState);        
    const setToast = useSetRecoilState(toastState);
    const setLoading = useSetRecoilState(loadingState);

    useEffect(() => {
        if(objetCur){
            setTitlePop('Éditer le nom de la collection');
            setCollectionName(objetCur.nom_collection);
        }else{
            setTitlePop('Ajouter une collection')
        }              
    }, [objetCur]);

    const onValidate = (collection) => {  
        if(collection && collection.trim() != ''){
            setLoading(true);
            let api = api_collection+ user_data.account.port+ '/';
            let userId = user_data.user.id;
            if(objetCur?.id){
                const collectionUpdate = { 
                    ...objetCur, 
                    nom_affiche: collection,
                    nom_collection: collection ,
                    sogefi_date_modification: new Date().toISOString().slice(0, 19).replace('T', ' '),
                    sogefi_operateur_modification: userId
                };
                updateCollection(api,userId,collectionUpdate);
            }else{
                addCollection(api,userId,collection); 
            }
        } else{
            setToast({ message: 'Veuillez saisir une collection avant de cliquer sur le bouton Valider.' , type: 'warning' });
        }
        
    };

    const updateCollection = (api, userId, collection) => {
        CollectionService.updateCollection(api,userId,collection).then((response) => {
            if(response.rows){
                setToast({ message: response.message , type: 'success' });   
                setCollections((prev) => 
                    prev.map((col) => 
                        col.id === collection.id
                        ? {
                            ...col,
                            nom_affiche: collection.nom_collection,
                            nom_collection: collection.nom_collection,
                            sogefi_date_modification: collection.sogefi_date_modification,
                            sogefi_operateur_modification: collection.sogefi_operateur_modification
                          }
                        : col
                    )
                );             
            } else {
                setToast({ message: response.message , type: 'error' });
            }     
            setLoading(false);    
            onClose();      
           
        });
    };

    const addCollection = (api, userId, collection) => {
        CollectionService.addCollection(api,userId,collection).then((response) => { 
            if(response.id){
                setToast({ message: response.message , type: 'success' });
                const newCollection = {
                    id: response.id,
                    nb_entite: 0,
                    nom_affiche: collection,
                    nom_collection: collection,
                    old_id: null,
                    sogefi_date: new Date().toISOString().slice(0, 19).replace('T', ' '), 
                    sogefi_date_modification: null,
                    sogefi_operateur_creation: userId,
                    sogefi_operateur_modification: null,
                };
                setCollections((prev) => [newCollection, ...prev]);
            } else {
                setToast({ message: response.message , type: 'error' });
            }     
            setLoading(false);    
            onClose();      
           
        });
    };

    return (
        <div className="row mb0">
            <div className="col s12">
                <p className="center-align font_size_22">
                    {titlePop}
                </p>
            </div>
            <div className="col s12 mb20">
                <div>
                    <span className="font_size_15 bgcolor_first-text">Nom de la collection</span>
                    <input
                        className={genStyles.inputtCol}
                        type="text"
                        value={collectionName}
                        placeholder="Ma collection"
                        maxLength={50}
                        onChange={(e) => setCollectionName(e.target.value)}
                    />
                </div>
            </div>
            <div className="col s12">
                <div className={genStyles.buttonfooter}>
                    <button
                        className="btn red lighten-1 z-depth-0 mr5 ml5"
                        style={{ width: '200px' }}
                        onClick={onClose}
                    >
                        Annuler
                    </button>
                    <button
                        className="btn green lighten-1 z-depth-0 mr5 ml5"
                        style={{ width: '200px' }}
                        onClick={() => onValidate(collectionName)}
                    >
                        Valider
                    </button>
                </div>
            </div>
        </div>
    );
}
